import {CheckboxTreeOptionType} from 'platform/components';

import {FeaturePickerItem} from '../types/FeaturePickerItem';

export const mapFeaturesRecursively = (feature: FeaturePickerItem): CheckboxTreeOptionType => ({
  value: feature.value,
  label: feature.label,
  options: feature.children?.map(mapFeaturesRecursively) ?? [],
});
